
const old = 'https://firebasestorage.googleapis.com/v0/b/amp--v2.appspot.com/o';
const updated = 'https://firebasestorage.googleapis.com/v0/b/amp-2-c2c4f.firebasestorage.app/o';

const url = data => {
    const after = data.split(old)[1];
    if (!after) return `url('${data}')`;

    const components = after.split('?alt=media&token');
    const path = components[0];
    const params = '?alt=media&token' + components[1];
    if (!path || !params) return `url('${data}')`;

    return `url('${updated}${path}${params}')`;
};

export default { url };
